import { Col, Flex } from "antd";
import React from "react";
import CardWrapper from "@/components/card/CardWrapper";
import IconDropDown from "@/components/icons/IconDropDown";
import { useNavigate } from "react-router-dom";
import { initiatePayment } from "@/services/payments/initiatePayment";
import { getPurchaseById } from "@/services/students/getPurchaseById";
import { bookSession } from "@/services/students/bookSession";
import { useDispatch } from "react-redux";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";

const PaymentMethod = ({ amount, data, isProductType }) => {
  console.log(data, "data");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCheckout = () => {
    if (isProductType) {
      getPurchaseById(data.id)
        .then((res) => {
          if (res.isComplimentary) {
            navigate("/dashboard");
            dispatch(setCurrentForm("productSuccess"));
            dispatch(setModalOpen(true));
          } else {
            initiatePayment({
              // amount: amount,
              // currency: "usd",
              transactionId: res.transactionId,
            })
              .then((response) => {
                navigate("/checkout", {
                  state: {
                    clientSecret: response.paymentToken,
                  },
                });
              })
              .catch((error) => console.log(error));
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            dispatch(setCurrentForm("successModal"));
            dispatch(setModalOpen(true));
            dispatch(
              setFormProps({
                message: "Product already purchased",
                btnLabel: "Explore other plans",
                onSubmit: () => {
                  navigate("/plans");
                  dispatch(setModalOpen(false));
                },
              })
            );
          }
        });
    } else {
      bookSession(data.guideId, {
        date: data.time[0].orignalDate,
        timeslots: data.time?.map((x) => ({ start: x.start, end: x.end })),
      })
        .then((res) => {
          initiatePayment({
            // amount: amount,
            // currency: "usd",
            transactionId: res.transactionId,
          })
            .then((response) => {
              console.log(response);
              navigate("/checkout", {
                state: {
                  clientSecret: response.paymentToken,
                },
              });
            })
            .catch((error) => console.log(error));
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Col xs={24} lg={11} className="card-wrapper">
      <Flex className="content-wrapper" gap="1rem" vertical>
        <div className="title-h5-1">Select Payment Method</div>
        {!data.isComplimentary ? (
          <CardWrapper className="payment-method-wrapper cursor-pointer" onClick={handleCheckout}>
            <Flex vertical gap="0.5rem">
              <div className="body-b4-1 label">Stripe Payment</div>
              <Flex align="center" gap="5px">
                <img src="/assets/images/stripeLogo.png" height="18px" />
                <Flex className="body-b3 w-100" justify="space-between" align="center">
                  <span className="body-b3 message">Pay securely with stripe</span>
                  <IconDropDown className="cursor-pointer" />
                </Flex>
              </Flex>
            </Flex>
          </CardWrapper>
        ) : (
          <CardWrapper className="payment-method-wrapper cursor-pointer" onClick={handleCheckout}>
            <Flex vertical gap="0.5rem">
              <div className="body-b4-1 label">Complimentary Product</div>
              <Flex align="center" gap="5px">
                {/* <img src="/assets/images/stripeLogo.png" height="18px" /> */}
                <Flex className="body-b3 w-100" justify="space-between" align="center">
                  <span className="body-b3 message">Proceed to Purchase</span>
                  <IconDropDown className="cursor-pointer" />
                </Flex>
              </Flex>
            </Flex>
          </CardWrapper>
        )}
      </Flex>
    </Col>
  );
};

export default PaymentMethod;
